import fetch from "node-fetch";
import FormData from "form-data";
import e from "turbolinks";

document.addEventListener("turbolinks:load", function (_event) {
  let id = (val) => document.getElementById(val);
  let target = id("audio_file");

  if (target) {
    let start = id("start"),
      stop = id("stop"),
      upload = id("upload"),
      remove = id("remove"),
      send = id("send"),
      back = id("back"),
      textarea = id("json"),
      stream,
      recorder,
      chunks;

    navigator.mediaDevices.getUserMedia({ audio: true }).then((_stream) => {
      stream = _stream;

      id("audio_actions").style.display = "inherit";
      start.removeAttribute("disabled");

      recorder = new MediaRecorder(stream);

      recorder.ondataavailable = (e) => {
        chunks.push(e.data);

        if (recorder.state == "inactive") {
          makeLink();
        }
      };
    });

    start.onclick = (_e) => {
      start.disabled = true;
      stop.removeAttribute("disabled");

      chunks = [];

      recorder.start();
    };

    stop.onclick = (_e) => {
      stop.disabled = true;

      recorder.stop();

      start.removeAttribute("disabled");
    };

    remove.onclick = (_e) => {
      upload.value = "";
      send.removeAttribute("disabled");
    };

    back.onclick = (_e) => {
      stream.getAudioTracks().forEach((track) => track.stop());
    };

    send.onclick = (_e) => {
      const file = upload.files[0];

      if (file) {
        send.disabled = true;

        sendAudio(file, { contentType: file.type, filename: file.name }).then(
          () => {
            send.removeAttribute("disabled");
          }
        );
      }
    };

    function sendAudio(file, options = {}) {
      const { contentType, filename } = options;

      textarea.value = "Enviando...";

      const form = new FormData();

      form.append("file", file, {
        contentType: contentType || "audio/ogg",
        filename: filename || "audio.ogg",
      });

      return fetch(window.location.href, { method: "POST", body: form })
        .then((response) => response.json())
        .then((body) => {
          textarea.value = JSON.stringify(body, null, 2);
        });
    }

    function makeLink() {
      let file = new Blob(chunks, { type: "audio/ogg" }),
        url = URL.createObjectURL(file),
        audio = document.createElement("audio");

      audio.controls = true;
      audio.src = url;

      target.innerHTML = "";
      target.appendChild(audio);

      sendAudio(file);
    }
  }
});
